import { testimonials } from '@/mocks/data';

export default function Testimonial() {
  const t = testimonials[0];

  return (
    <section className="py-10 md:py-14 px-4 md:px-8 bg-background-50 relative overflow-hidden">
      <div className="absolute top-0 left-0 w-64 h-64 opacity-10">
        <svg viewBox="0 0 200 200" className="w-full h-full text-foreground-900">
          <path
            d="M40,180 Q20,150 30,120 Q40,90 70,80 Q100,70 120,50 Q140,30 160,40 Q180,50 170,80 Q160,110 140,130 Q120,150 100,170 Q80,190 60,180 Z"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
          />
        </svg>
      </div>

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="flex flex-col lg:flex-row gap-0">
          <div className="w-full lg:w-[35%] relative">
            <div className="lg:absolute lg:-left-8 lg:-top-4 lg:-bottom-4">
              <img
                src={t.image}
                alt={t.name}
                title={t.name}
                className="w-full lg:w-auto lg:h-[420px] object-cover rounded-2xl lg:rounded-3xl"
                loading="lazy"
              />
            </div>
          </div>

          <div className="w-full lg:w-[65%] bg-primary-500 rounded-2xl lg:rounded-3xl p-8 md:p-12 lg:p-16 mt-6 lg:mt-0">
            <div className="text-accent-100 text-6xl md:text-8xl font-serif leading-none mb-4 md:mb-6">
              "
            </div>
            <blockquote className="text-base md:text-xl text-background-50 leading-relaxed max-w-xl">
              {t.quote}
            </blockquote>
            <div className="mt-6 md:mt-8">
              <p className="text-sm md:text-base font-semibold text-background-50">{t.name}</p>
              <p className="text-xs md:text-sm text-background-50/60 mt-1">{t.role}</p>
            </div>
            <button className="mt-6 md:mt-8 px-6 py-2.5 rounded-full bg-secondary-400 text-primary-900 text-sm font-semibold hover:bg-secondary-500 transition-colors cursor-pointer whitespace-nowrap">
              加入吃瓜大军
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}